// ============================================================
// Cart – Ball Animation on Add to Cart
// ============================================================

(function() {
  function createBallAnimation(originX, originY) {
    const cartIcon = document.querySelector('.header__icon--cart');
    if (!cartIcon) return;

    const cartRect = cartIcon.getBoundingClientRect();
    const targetX = cartRect.left + cartRect.width / 2;
    const targetY = cartRect.top + cartRect.height / 2;

    const ball = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    ball.setAttribute('width', '32');
    ball.setAttribute('height', '32');
    ball.setAttribute('viewBox', '0 0 32 32');
    ball.innerHTML = `
      <circle cx="16" cy="16" r="14" fill="white" stroke="black" stroke-width="1.5"/>
      <path d="M16 2 C16 2 20 8 20 16 C20 24 16 30 16 30" fill="none" stroke="black" stroke-width="1.2"/>
      <path d="M2 16 C2 16 8 12 16 12 C24 12 30 16 30 16" fill="none" stroke="black" stroke-width="1.2"/>
      <path d="M5 7 C5 7 10 10 16 10 C22 10 27 7 27 7" fill="none" stroke="black" stroke-width="1"/>
      <path d="M5 25 C5 25 10 22 16 22 C22 22 27 25 27 25" fill="none" stroke="black" stroke-width="1"/>
      <path d="M2 16 C2 16 5 25 10 27" fill="none" stroke="black" stroke-width="1"/>
      <path d="M30 16 C30 16 27 25 22 27" fill="none" stroke="black" stroke-width="1"/>
    `;

    ball.style.cssText = `
      position: fixed;
      left: ${originX - 16}px;
      top: ${originY - 16}px;
      z-index: 9999;
      pointer-events: none;
      transition: none;
      filter: drop-shadow(0 2px 4px rgba(0,0,0,0.2));
    `;

    document.body.appendChild(ball);

    const deltaX = targetX - originX;
    const deltaY = targetY - originY;
    const duration = 1200;
    const startTime = performance.now();

    function animate(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Ease in-out
      const eased = progress < 0.5
        ? 2 * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 2) / 2;

      // Arc – nach oben
      const arcHeight = Math.min(Math.abs(deltaY), 150);
      const arcY = -Math.sin(progress * Math.PI) * arcHeight;

      const currentX = originX + deltaX * eased - 16;
      const currentY = originY + deltaY * eased + arcY - 16;
      const rotation = progress * 720;
      const scale = 1 - progress * 0.5;

      ball.style.left = currentX + 'px';
      ball.style.top = currentY + 'px';
      ball.style.transform = `rotate(${rotation}deg) scale(${scale})`;
      ball.style.opacity = progress > 0.85 ? (1 - (progress - 0.85) / 0.15) : 1;

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        ball.remove();
        // Cart icon bounce
        if (cartIcon) {
          cartIcon.style.transform = 'scale(1.3)';
          cartIcon.style.transition = 'transform 0.15s ease';
          setTimeout(() => {
            cartIcon.style.transform = 'scale(1)';
          }, 150);
        }
      }
    }

    requestAnimationFrame(animate);
  }

  // Trigger on Add to Cart button click
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[name="add"], .product-form__submit, #ProductSubmitButton');
    if (!btn) return;

    const rect = btn.getBoundingClientRect();
    const originX = rect.left + rect.width / 2;
    const originY = rect.top + rect.height / 2;

    // Kurze Verzögerung damit Shopify erst verarbeitet
    setTimeout(() => {
      createBallAnimation(originX, originY);
    }, 100);
  });

})();

// ============================================================
// Fix: Close cart drawer when clicking outside – empty cart
// ============================================================

document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  cartDrawer.addEventListener('click', function(e) {
    if (!e.target.closest('.drawer__inner')) {
      cartDrawer.close();
    }
  });
});

/* Floating cart count sync — keeps the badge live via Dawn's pubsub */
(function () {
  const trigger = document.querySelector('#cart-icon-bubble.floating-cart');
  if (!trigger) return;

  const countEl = trigger.querySelector('[data-cart-count]');
  const a11yEl = trigger.querySelector('[data-cart-count-a11y]');

  function render(count) {
    if (countEl) {
      countEl.textContent = count;
      countEl.classList.toggle('floating-cart__count--hidden', count === 0);
    }
    if (a11yEl) a11yEl.textContent = count;
  }

  function refreshFromServer() {
    const base = (window.routes && window.routes.cart_url) || '/cart';
    fetch(`${base}.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => render(cart.item_count))
      .catch(() => {});
  }

  // Dawn publishes cartUpdate on add / remove / quantity change
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshFromServer);
  }
})();
